import { StoreMarkerIcon } from './StoreMarkerIcon';

/**
 * author: Colton Wiscombe
 * id 9F2B1901-978F-4186-93BA-2B2871A1858A
 * name store-marker
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-marker.svg
 * tags
 * - Places 
 * - Shopping 
 * - Navigation 
 */
export const ShopMarkerIcon = StoreMarkerIcon;
export default ShopMarkerIcon